import React__default, { forwardRef, useRef } from 'react';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// ------------------------------------------------------
// Root
/** Contains all the parts of a scroll area. */
const Root = /*#__PURE__*/forwardRef(({
  children,
  sx: sxProp,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ScrollAreaPrimitive.Root, _extends({
    ref: innerRef
  }, props), children);
});

// ------------------------------------------------------
// Viewport
/** The viewport area of the scroll area.  */
const Viewport = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ScrollAreaPrimitive.Viewport, _extends({
    ref: innerRef
  }, props), children);
});

// ------------------------------------------------------
// Scrollbar
/** The vertical scrollbar. Add a second Scrollbar with an orientation prop to enable horizontal scrolling. */
const Scrollbar = /*#__PURE__*/forwardRef(({
  children,
  testId,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ScrollAreaPrimitive.Scrollbar, _extends({
    ref: innerRef,
    "data-testid": testId
  }, props), children);
});
// ------------------------------------------------------
// Thumb
/** The thumb to be used in ScrollArea.Scrollbar. */
const Thumb = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ScrollAreaPrimitive.Thumb, _extends({
    ref: innerRef
  }, props), children);
});
// ------------------------------------------------------
// Corner
/** The corner where both vertical and horizontal scrollbars meet. */
const Corner = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ScrollAreaPrimitive.Corner, _extends({
    ref: innerRef
  }, props), children);
});

// Exports
Root.displayName = 'ScrollArea';
Viewport.displayName = 'Viewport';
Scrollbar.displayName = 'Scrollbar';
Thumb.displayName = 'Thumb';
Corner.displayName = 'Corner';
var ScrollArea = Object.assign(Root, {
  Viewport,
  Scrollbar,
  Thumb,
  Corner
});

export { Corner, Root, Scrollbar, Thumb, Viewport, ScrollArea as default };
